module.exports = __webpack_public_path__ + "static/media/  (7).08715440.jpg";